"use strict";
// partsから必要分のみimport

import "./parts/_accordion.js";
// import "./parts/_back-to-top.js";
import "./parts/_drawer.js";
// import "./parts/_fadeIn.js";
import "./parts/_fixed-viewport.js";
// import "./parts/_form-validation.js";
import "./parts/_input_check.js";
// import "./parts/_loading.js";
// import "./parts/_modal.js";
import "./parts/_observer.js";
// import "./parts/_scroll-header.js";
import "./parts/_slider.js";
import "./parts/_smooth-scroll.js";
import "./parts/_custom-placeholder.js";
// import "./parts/_to-top.js";
// import "./parts/_validation.js";
